import { render } from "./InstallationProcedure.vue?vue&type=template&id=3a9a3b96"
import script from "./InstallationProcedure.vue?vue&type=script&lang=js"
export * from "./InstallationProcedure.vue?vue&type=script&lang=js"
script.render = render

export default script